<script>
import en from './languages/en.vue'
import it from './languages/it.vue';
import es from './languages/es.vue';
import de from './languages/de.vue';
import fr from './languages/fr.vue';


export default 
  {
    en: en,
    it: it,
    es: es,
    de: de,
    fr: fr
  }
</script>
